<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="1200"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <GoodsInfo
          :disabled="disabled"
          :hxSpuCode="hxSpuCode"
          :isCopy="isCopy"
          @isSkuCopy="onSkuCopy"
          :hxSkuCode="hxSkuCode"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import GoodsInfo from '@/views/ecom/base/hxGoods/components/hx-good-info'
export default {
  components: { GoodsInfo },
  props: {
    visible: { type: Boolean, default: false },
    optType: { type: String, default: '' },
    hxSpuCode: { type: String, default: '' },
    hxSkuCode: { type: String, default: '' },
  },
  data() {
    return {
      titleMap: {
        edit: this.$l('INDEX.dialog_title_edit_SKU') || '编辑SKU',
        add: this.$l('INDEX.dialog_title_Add_SKU') || '新增SKU',
        detail: this.$l('INDEX.dialog_title_SKU_detail') || 'SKU详情',
        copy: '复制SKU',
      },
      isSkuCopy: true
    }
  },
  computed: {
    title() {
      return this.titleMap[this.optType]
    },
    disabled() {
      return this.optType === 'detail'
    },
    isCopy() {
      return this.optType === 'copy' && this.isSkuCopy
    },
  },
  methods: {
    onSkuCopy() {
      this.isSkuCopy = false
    },
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    handleClose(done) {
      if (this.disabled) return done()
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => done())
        .catch(() => {})
    },
  },
}
</script>
